import axios from 'axios';

// Curriculum files are published to the same static bucket as the standards
// files, by the `curriculum` command in diffit-standards. Same host split as
// SkillService: prod reads `standards/`, everything else `standards-dev/`.
const CurriculumClient = axios.create({
  baseURL: `https://static.diffit.me/standards${window.location.host !== 'app.diffit.me' ? '-dev' : ''}/curriculum`,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * The course index for a curriculum.
 * @param {string} curriculumId - an id from the curricula.json index
 * @returns {Promise<Array>} [{ id, slug, name, course_code, grade_levels, lesson_count }]
 *   already ordered Kindergarten → Grade 8 → high school by the publishing tool.
 */
export async function getCurriculumCourses(curriculumId) {
  const response = await CurriculumClient.get(`/${curriculumId}/courses.json`);
  return response.data?.courses ?? [];
}

/**
 * One course's unit → lesson tree, with the standards each lesson teaches inline.
 * @param {string} curriculumId - an id from the curricula.json index
 * @param {string} slug - Course slug from the index (e.g. 'im360-6')
 * @returns {Promise<Object>} { course_id, course_name, units: [{ label, lessons: [...] }] }
 */
export async function getCurriculumCourse(curriculumId, slug) {
  const response = await CurriculumClient.get(`/${curriculumId}/${slug}.json`);
  return response.data;
}

let indexRequest = null;

/**
 * Every published curriculum, fetched once per page load.
 * @returns {Promise<Array>} [{ id, name, display_name, subject, grades, publisher, source, access, attribution, license }]
 */
export function getCurricula() {
  indexRequest ||= CurriculumClient.get('/curricula.json')
    .then((response) => response.data?.curricula ?? [])
    .catch((error) => {
      indexRequest = null;
      throw error;
    });
  return indexRequest;
}
